module.exports = __webpack_public_path__ + "img/settingsGear_b.9812acae.svg";